import React from 'react';
import Page from '../../Page';
import PluginVersions from './PluginVersions';
import { updateWithDelimiter } from '../../../util/stringUtils';
import { toPublicResource } from '../../../util/pathUtils';
import plugins from '../../../../public/media/Plugins/json/plugins.json';
import './pluginsPage.scss';

const PluginsPage = () => {

    return (<Page header="Plugins">
        <div id='plugins-page'>
            <div className='panel-container'>
                {plugins
                    ?.filter((p) => (p?.name?.length > 0
                        && p?.versions?.length > 0
                        && p?.versions?.some((e) => (e?.pluginType?.length > 0 
                            && e?.platformVersion?.length > 0
                            && e?.pluginVersion?.length > 0))
                    ))
                    ?.map((p, i) => {

                    const imagePath = toPublicResource(`/media/plugins/imgs/${updateWithDelimiter(p.name)}.png`);

                    const browsers = p.versions
                        .filter((v) => (v.pluginType.toLowerCase() === 'browser'));
                    const redirects = p.versions
                        .filter((v) => (v.pluginType.toLowerCase() === 'redirect'));

                    return (<div key={`${p.name}-${i}`} className='panel'>
                        
                        <img src={`${imagePath}`} alt={`Plugin ${p.name}`} />
                        <div>
                            <p>{p?.description}</p>
                            <div className='downloads-container'>
                                {browsers &&
                                    <PluginVersions
                                        heading='Seamless integration connecting through our API'
                                        name={p.name}
                                        versions={browsers}
                                    />
                                }

                                {redirects &&
                                    <PluginVersions
                                        heading='Redirect to our secure hosted payment page'
                                        subtitle={p.name === 'WooCommerce' ? 'Must use if 3DSecure is enabled.' : null}
                                        name={p.name}
                                        versions={redirects}
                                    />
                                }
                            </div>
                        </div>
                    </div>)
                })}
            </div>
        </div>
    </Page>);
}

export default PluginsPage;
